<template>
	<div class="form_box">
		<el-table empty-text="暂无数据" :data="tableData" border>
			<el-table-column prop="number" label="序号" min-width="50%"></el-table-column>
			<el-table-column prop="casenumber" label="案件编号" min-width="80%"></el-table-column>
			<el-table-column prop="address" label="发生地点" min-width="100%"></el-table-column>
			<el-table-column prop="username" label="用户姓名" min-width="50%"></el-table-column>
			<el-table-column prop="phone" label="用户手机号" min-width="70%"></el-table-column>
			<el-table-column prop="papers" label="证件信息" min-width="80%"></el-table-column>
			<el-table-column prop="sex" label="性别" min-width="50%"></el-table-column>
			<el-table-column prop="time" label="出险时间" min-width="90%"></el-table-column>
			<el-table-column prop="par" label="用户保险详情" min-width="70%">
				<template slot-scope="scope">
					<el-button type="text" size="small" v-show="scope.row.isshow" @click="toUrl(scope.row.insuranceUrl)">保险详情</el-button>
					<el-button type="text" size="small" v-show="!scope.row.isshow">无</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="plan" label="当前进度" min-width="80%"></el-table-column>
			<el-table-column prop="node" label="当前节点" min-width="60%"></el-table-column>
			<el-table-column label="处理单位">
				<template slot-scope="scope">
					<p v-for="item in scope.row.assigned">{{item.name}}</p>
				</template>
			</el-table-column>
			<el-table-column prop="get_time" label="到达时间" min-width="90%"></el-table-column>
			<el-table-column prop="op" label="操作" min-width="110%">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="topar(scope.$index)">查看并操作</el-button>
				</template>
			</el-table-column>
		</el-table>
    <el-pagination
        style="margin-top: 15px; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[10]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
	</div>
</template>

<script>
import 'isomorphic-fetch';
import constants from '@/util/constants.js';
export default {
	props: ['token', 'st_time', 'en_time', 'sereen', 'typeId','victimUser', 'caseNumber'],
	data() {
		return {
			tableData: [],
			obj: [],
			victimList: [],
      start: 0,
      count: 10,
      total: 50,
      currentPage4: 1,
		};
	},
	computed: {
    handleSizeChange(val) {
      this.count = val;
      this.getData();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.start = (val - 1) * this.count;
      // this.start = val * 10
      this.getData();
      console.log(`当前页: ${val}`);
    },
		languageIndex() {
			return this.$store.state.language;
		}
	},
	methods: {
		topar(index) {
			let that = this;
			console.log(that);
			this.$router.push({
				name: 'RegPar',
				params: {
					token: that.token,
					obj: that.obj,
					victimList: that.victimList,
					index
				},
				query: {
					typeId: this.typeId,
					caseid: this.obj[index].id
				}
			});
		},

		toUrl(url) {
			window.open(url);
		},
		getData(st, et) {
      var _this = this
      console.log(_this)
			this.tableData = [];
			let that = this;
			let n = 0;
			let sex = '';
			let isshow = false;
			let stTime = st || this.st_time;
			let enTime = et || this.en_time;
			let tl = '';
			if (stTime && enTime) {
				tl = tl + `&startTs=${stTime}&endTs=${enTime}`;
			}
			if (this.caseNumber) {
				tl = tl + `&casenumber=${this.caseNumber}`;
			}
			fetch(constants.domain + 'rescue/case/list_case', {
				method: 'POST',
				body: `token=${this.token || JSON.parse(window.localStorage.getItem('token')).obj}&typeId=${this.typeId}&status=120` + tl,
				mode: 'cors',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			})
				.then(function(res) {
					console.log('请求了await');
					return res.json();
				})
				.then(function(data) {
					console.log(data);
					if (data.obj) {
            // this.total = data.total
						data.obj.map(v => {
							n = n + 1;
							if (v.victimList[0].obj.gender == 1) {
								sex = '男';
							} else {
								sex = '女';
							}
							if (v.victimList[0].obj.insurancePolicyNo && v.victimList[0].obj.insurancePolicyNo != '') {
								isshow = true;
							} else {
								isshow = false;
							}
							var pt = constants.pt2txt3(v.obj.caseState);
							var address = '';
							if (v.generalLocation) {
								if (!constants.setTxt(v.generalLocation.addr, 'zh')) {
									address = v.generalLocation.addr;
								} else {
									address = that.languageIndex == 0 ? constants.setTxt(v.generalLocation.addr, 'zh') : constants.setTxt(v.generalLocation.addr, 'en');
								}
							}

							that.tableData.push({
								number: n, //序号
								casenumber: v.obj.caseNo, //案件编号
								address, //地址
								username: v.victimList[0].obj.victimName, //姓名
								phone: v.obj.reporterContact, //联系方式
								papers: v.victimList[0].obj.idNo || '无', //身份证号
								sex: sex, //性别
								time: constants.time(v.obj.incidentTs), //出险时间
								insuranceUrl: v.insuranceUrl,
								plan: pt.phase, //进度
								node: pt.node, //节点
								isshow: isshow,
								get_time: constants.time(v.obj.incidentTs),
								op: '查看并操作',
								assigned:v.assigned
							});
							that.obj.push(v.obj);
							that.victimList.push(v.victimList[0]);
						});
					}
				});
		}
	},
	watch: {
		en_time(nv, ov) {
			console.log(nv, ov);
			// this.getData(0, nv + 86400000);
		},
		st_time(nv, ov) {
			console.log(nv, ov);
			// this.getData(nv, 0);
		},
		sereen(nv, ov) {
			console.log(nv);
			if (nv) {
				this.getData(this.st_time, this.en_time + 86400000);
			}
		},
		caseNumber(nv, ov) {
			console.log('案件编号变化:', nv);
			this.getData();
		},
		languageIndex() {
			this.getData();
		}
	},
	mounted() {
		// if (this.flag) {
		this.getData();
		// } else {
		// }
	}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/regulator/form.vue